import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import FMPHeadline from '../../components/ui/FMPHeadline';
import LoadingAssignmentsContainer from '../../containers/logistics/LoadingAssignments';
import { Button, Table, TableBody, TableCell, TableRow } from '@material-ui/core';

const styles = (theme) => ({
	paper: {
		width: '100%',
		overflowX: 'auto',
		textAlign: 'left',
		boxSizing: 'border-box',
		padding: 20,
		[theme.breakpoints.up('md')]: {
			padding: '10px 20px 20px 20px',
		},
	},
	table: {
		width: '100%',
		tableLayout: 'auto',
	},
	row: {
		cursor: 'pointer',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	stats: {
		padding: '20px 10px 20px 10px',
		borderBottom: '1px solid #ddd',
		marginBottom: 10,
	},
	statGroup: {
		padding: '5px 5px 10px 5px',
		borderBottom: '1px solid #eee',
		marginBottom: 10,
	},
	available: {
		fontWeight: 900,
	},
});

class LoadingAssignments extends Component {
	constructor(props) {
		super(props);
		this.state = {
			assignmentStats: [],
			order: 'desc',
			orderBy: 'dateUsedSort',
			search: '',
		};
	}

	componentDidMount() {
		if (!this.props.loadingAssignments.length) {
			this.props.searchLoadingAssignments();
		}
		if (!this.state.assignmentStats.length) {
			this.props.getLoadingAssignmentStats({
				callback: (err, r) => {
					if (err) {
						return this.props.showErrors([err]);
					}

					/** @namespace r.assignmentsStats **/
					this.setState({ assignmentStats: r.assignmentStats });
				},
			});
		}
	}

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleRequestSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	handleHide = (loadingAssignmentId) => {
		const { removeLoadingAssignment } = this.props;
		removeLoadingAssignment({
			loadingAssignmentId,
			callback: () => {
				this.props.searchLoadingAssignments();
				this.props.getLoadingAssignmentStats({
					callback: (err, r) => {
						if (err) {
							return this.props.showErrors([err]);
						}

						/** @namespace r.assignmentsStats **/
						this.setState({ assignmentStats: r.assignmentStats });
					},
				});
			},
		});
	};

	render() {
		const { classes, loadingAssignments, canMakeUpdates, terminalMap, supplierMap } = this.props;
		const { assignmentStats } = this.state;

		if (!loadingAssignments) {
			return <div>Loading the numbers...</div>;
		}
		if (!assignmentStats) {
			return <div>Loading stats...</div>;
		}

		const stats = [];
		assignmentStats.forEach((stat) => {
			const { terminalId, supplierId, available, availableLoadingAssignments } = stat;

			const terminal = terminalMap[terminalId];
			const terminalDisplay = terminal ? terminal.name : 'Missing Terminal';

			const supplier = supplierMap[supplierId];
			const supplierDisplay = supplier ? supplier.name : 'Missing Supplier';

			stats.push({
				terminalDisplay,
				supplierDisplay,
				available,
				availableLoadingAssignments,
			});
		});

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline
						label="Available Loading Numbers"
						value={this.state.search}
						url="/logistics/loadingAssignment/add"
						buttonText="IMPORT LOADING NUMBERS"
						canMakeUpdates={canMakeUpdates}
					/>

					<Paper className={classes.paper}>
						<div className={classes.stats}>
							<Grid container spacing={2}>
								<Grid item xs={12} md={12}>
									{stats.map((stat, i) => {
										return (
											<div key={i} className={classes.statGroup}>
												<div className={classes.terminal}>{stat.terminalDisplay}</div>
												<div className={classes.supplier}>Supplier : {stat.supplierDisplay}</div>
												<div className={classes.available}>
													Available Loading Numbers : {stat.available}
												</div>
												<div style={{ paddingTop: 10 }}>
													<u>Loading Number / Date Created</u>
												</div>
												<Table style={{ display: 'flex' }}>
													<TableBody>
														{stat.availableLoadingAssignments.map(
															({ loadingAssignmentId, loadingNumber, dateCreated }) => {
																return (
																	<TableRow
																		key={loadingAssignmentId}
																		style={{ borderBottom: '1px solid #eee' }}
																	>
																		<TableCell style={{ padding: 5, fontSize: 15 }}>
																			{loadingNumber} /{' '}
																			{moment(dateCreated).format('dddd, MMMM Do, YYYY')}
																		</TableCell>
																		<TableCell style={{ padding: 5 }}>
																			<Button
																				style={{ marginLeft: 10 }}
																				size="small"
																				color="primary"
																				variant="outlined"
																				className={classes.addInputButton}
																				onClick={() => this.handleHide(loadingAssignmentId)}
																			>
																				Hide
																			</Button>
																		</TableCell>
																	</TableRow>
																);
															}
														)}
													</TableBody>
												</Table>
											</div>
										);
									})}
								</Grid>
							</Grid>
						</div>
					</Paper>
				</Grid>
			</Grid>
		);
	}
}

LoadingAssignments.propTypes = {
	classes: PropTypes.object.isRequired,
	searchLoadingAssignments: PropTypes.func.isRequired,
	loadingAssignments: PropTypes.array,

	removeLoadingAssignment: PropTypes.func.isRequired,

	getLoadingAssignmentStats: PropTypes.func.isRequired,
	showErrors: PropTypes.func.isRequired,

	supplierMap: PropTypes.object,
	carrierMap: PropTypes.object,
	terminalMap: PropTypes.object,
	stationDeliveryMap: PropTypes.object,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,

	canMakeUpdates: PropTypes.bool,
};

export default _.flow([withStyles(styles), LoadingAssignmentsContainer])(LoadingAssignments);
